// extracted by mini-css-extract-plugin
export default {"downloadSectionHeaderContainer":"Documents_downloadSectionHeaderContainer__xSmT0","widgetContainer":"Documents_widgetContainer__DWDus"};